module.exports = __webpack_public_path__ + "static/mrc_chart3.70cfa0c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mrc_chart3.png
// module id = 1368
// module chunks = 14018417377433 170120657441983